// extracted by mini-css-extract-plugin
export var lab = "Lab-module--lab--3Y2-j";
export var title = "Lab-module--title--S0yNl";
export var description = "Lab-module--description--3gBAC";
export var technologiesList = "Lab-module--technologiesList--2R-ah";